// extracted by mini-css-extract-plugin
export default {"limboSubmitButtonWrap":"styles_limboSubmitButtonWrap__bc7ds","limboSubmitButton":"styles_limboSubmitButton__SbJhp","limboSubmitButtonText":"styles_limboSubmitButtonText__pyLSx"};